var _style, _rect, _path, _path2, _rect2, _rect3, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddPersonWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#333333;}\r\n\t.st1{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 96,
    height: 96
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54.2,48.4c-5.7,0-10.4-4.7-10.4-10.4c0-5.7,4.7-10.4,10.4-10.4S64.6,32.2,64.6,38c0,0,0,0,0,0 C64.6,43.7,59.9,48.4,54.2,48.4z M54.2,28.4c-5.3,0-9.6,4.3-9.6,9.6s4.3,9.6,9.6,9.6c5.3,0,9.6-4.3,9.6-9.6c0,0,0,0,0,0 C63.8,32.7,59.5,28.4,54.2,28.4L54.2,28.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.6,68.4H33.8V63c0-6.8,13.3-10.4,20.4-10.4S74.6,56.2,74.6,63V68.4z M34.6,67.6h39.2V63 c0-6.2-13-9.6-19.6-9.6S34.5,56.8,34.5,63L34.6,67.6z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28.8,
    y: 35.5,
    className: "st1",
    width: 0.8,
    height: 20
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.1,
    y: 45.1,
    className: "st1",
    width: 20,
    height: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48,95.9C21.6,95.9,0.1,74.4,0.1,48S21.6,0.1,48,0.1S95.9,21.6,95.9,48C95.8,74.4,74.4,95.8,48,95.9z M48,0.9 C22,0.9,0.9,22,0.9,48S22,95.1,48,95.1S95.1,74,95.1,48l0,0C95,22,74,1,48,0.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPersonWhite);
export default __webpack_public_path__ + "static/media/add_person_white.7675fdfb9b673a0036731876356a007a.svg";
export { ForwardRef as ReactComponent };